angular.module('admin.directives')

.directive('mailto', ['MailtoService',
  function(MailtoService){
  return {
    controllerAs: 'mailToCtrl',
    bindToController: {
      agent: '=',
      home: '=',
      rea: '=',
      requester: '=',
      emailType: '@',
    },
    scope: {},
    restrict: 'A',

    controller: function(){
      let ctrl = this;

      const options = {
        home: ctrl.home,
        agent: ctrl.agent,
        user: ctrl.requester,
        rea: ctrl.rea,
      };

      let mailtoBuilder = MailtoService.create(ctrl.emailType, options);

      ctrl.getMailTo = function(){
        return mailtoBuilder.buildMailto();
      }
    },

    link: function($scope, el, attrs, ctrl){
      el[0].setAttribute('href', '');

      el.on('click', function(){
        el[0].setAttribute('href', `mailto:${ctrl.getMailTo()}`);
      });
    }
  }

}]);
